import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'ml-3 flex max-w-[1366px] gap-5 lg:mx-auto',
    item: 'overflow-hidden rounded-[20px] [perspective:1000px] lg:rounded-[32px]',
    image:
      'w-[324px] transition-transform duration-500 ease-out will-change-transform lg:w-[397px]',
    imageFlipped:
      'w-[324px] [transform:rotateY(180deg)] transition-transform duration-500 ease-out will-change-transform lg:w-[397px]',
    arrowPrev:
      'text-brand-bioderma top-auto right-[calc(50%)] -bottom-20 left-auto z-10 !block bg-transparent md:-bottom-[76px]',
    arrowNext:
      'text-brand-bioderma top-auto right-auto -bottom-20 left-[calc(50%)] z-10 !block bg-transparent md:-bottom-[76px]'
  }
});
